/* eslint key-spacing: ["error", { "beforeColon": true, "mode": "minimum" }] */
const yandexCounters = {
  omsk        : 144326,
  kazan       : 2001400,
  irkutsk     : 25729259,
  brn         : 27377348,
  kemerovo    : 27377504,
  krasnodar   : 27377516,
  krs         : 27377546,
  msk         : 27377585,
  nsk         : 27377600,
  rostov      : 27377618,
  samara      : 27377639,
  spb         : 27377669,
  sochi       : 27377699,
  tmn         : 27377720,
  chelyabinsk : 27377744
};

export function getYandexCounterId (domainName) {
  return yandexCounters[domainName] || null;
}

export function sendEvent (targetName, param = {}) {
  try {
    param.version = 2;
    window.yaCounter && window.yaCounter.reachGoal(targetName, param);
  } catch (e) {}
}

export function sendEventN1 (targetName, param = {}) {
  try {
    param.version = 2;
    window.yaCounter25608281 && window.yaCounter25608281.reachGoal(targetName, param);
  } catch (e) {}
}

export function navigate (url, referer) {
  try {
    window.yaCounter && window.yaCounter.hit(url, {
      referer
    });
    window.yaCounter25608281 && window.yaCounter25608281.hit(url, {
      referer
    });
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/utils/yandexMetrika.js